import React from "react";
import "./style.css";
import {QuestionnaireMultiple} from "../../../../components/QuestionnaireMultiple";

export const AchieveGoal = (props) => {
  const list = {
    title: "What are you willing to do to achieve your goal?",
    list: [
      { value: 'Count calories' },
      { value: 'Follow a personalized nutrition plan' },
      { value: 'Do some physical activity' },
      { value: 'Fast' },
      { value: 'Other' }
    ]
  };

  return (
    <div className="gallery-page">
      <QuestionnaireMultiple {...props} list={list} />
    </div>
  );
};
